import { render, staticRenderFns } from "./CorporationM.vue?vue&type=template&id=69aa2d2a"
import script from "./CorporationM.vue?vue&type=script&lang=js"
export * from "./CorporationM.vue?vue&type=script&lang=js"
import style0 from "./CorporationM.vue?vue&type=style&index=0&id=69aa2d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports